<template>
	<div>
		<Loader :show="loading"></Loader>

		<FormulateForm v-model="loginForm" ref="form" class="p-2" @submit="login">
			<FormulateInput
				:label="$t('email')"
				name="email"
				type="email"
				validation-name="Email"
				validation="email"
				class="mb-3"
			/>
			<FormulateInput
				:label="$t('password')"
				name="password"
				type="password"
				validation-name="Contraseña"
				validation="required"
				class="mb-3"
			/>

			<div class="d-flex justify-content-end mb-3">
				<router-link tag="a" :to="`/forgot-password`">{{ $t("forgetPassword") }}</router-link>
			</div>

			<div class="alert text-danger" v-if="loginError">
				{{ $t("loginError") }}
			</div>

			<div class="terms">
				Al comprar o iniciar sesión, acepta nuestros terminos y condiciones y reconoce nuestro aviso de
				privacidad.
			</div>

			<div class="form-group text-right mb-0">
				<button class="btn btn-primary btn-block" type="submit" :disabled="procesing">
					<span v-if="procesing">{{ $t("loginin") }} <span class="btn-loader"/></span>
					<span v-if="!procesing">{{ $t("login") }}</span>
				</button>
			</div>
		</FormulateForm>

		<div class="or mt-4 mb-4"></div>

		<router-link
			class="btn btn-block btn-text"
			tag="a"
			:to="redirectTo ? `/register?redirectTo=${redirectTo}` : `/register`"
			>{{ $t("notRegistered") }}</router-link
		>
	</div>
</template>

<script>
import gql from "graphql-tag"
import { onLogin } from "@/vue-apollo"
import Loader from "@/components/Loader"

export default {
	name: "Login",
	metaInfo() {
		return {
			title: "Iniciar sesión"
		}
	},
	components: {
		Loader
	},
	props: ["redirectTo"],
	data() {
		return {
			loading: false,
			procesing: false,
			loginError: false,
			loginForm: {
				email: "",
				password: ""
			}
		}
	},

	methods: {
		loginFacebook(user) {
			if (user.status == "connected" && user.authResponse) {
				const fToken = user.authResponse.accessToken
				const userId = user.authResponse.userID

				if (!this.loginIn && fToken != "" && userId != "") {
					this.procesing = true

					return this.$apollo
						.mutate({
							mutation: gql`
								mutation($fToken: String!, $userId: String!) {
									userLoginFacebook(fToken: $fToken, userId: $userId) {
										token
										user {
											id
											name
											lastname
											email
											phone {
												countryCode
												national
												international
												type
												validated
											}
											birthdate
											document {
												type
												number
											}
											addressCountry {
												id
												name
											}
											addressCity
											addressStreet
										}
									}
								}
							`,
							variables: {
								fToken,
								userId
							}
						})
						.then((data) => {
							console.log("loged with facebook", data)
							this.loginSuccess(data.data.userLoginFacebook.token, data.data.userLoginFacebook.user)
						})
						.catch(() => {
							this.loginError = true
							this.procesing = false
						})
				}
			}
		},

		loginGoogle(googleUser) {
			this.loginError = false
			const gToken = googleUser.getAuthResponse().id_token

			if (!this.loginIn && gToken != "") {
				this.procesing = true

				return this.$apollo
					.mutate({
						mutation: gql`
							mutation($gToken: String!, $publicKey: String!) {
								userLoginGoogle(gToken: $gToken, publicKey: $publicKey) {
									token
									user {
										id
										name
										lastname
										email
										phone {
											countryCode
											national
											international
											type
											validated
										}
										birthdate
										document {
											type
											number
										}
										addressCountry {
											id
											name
										}
										addressCity
										addressStreet
									}
								}
							}
						`,
						variables: {
							gToken,
							publicKey: process.env.VUE_APP_CARCHECK_PK
						}
					})
					.then((data) => {
						console.log("loged with google", data)
						this.loginSuccess(data.data.userLoginGoogle.token, data.data.userLoginGoogle.user)
					})
					.catch(() => {
						this.loginError = true
						this.procesing = false
					})
			}
		},

		login() {
			this.loginError = false
			if (!this.loginIn && this.loginForm.email != "" && this.loginForm.password != "") {
				this.procesing = true

				return this.$apollo
					.mutate({
						mutation: gql`
							mutation($email: String!, $password: String!) {
								userLogin(email: $email, password: $password) {
									token
									user {
										id
										name
										lastname
										email
										phone {
											countryCode
											national
											international
											type
											validated
										}
										document {
											type
											number
										}
										isPromotor
									}
								}
							}
						`,
						variables: {
							email: this.loginForm.email,
							password: this.loginForm.password
						}
					})
					.then(({ data }) => {
						this.loginSuccess(data.userLogin.token, data.userLogin.user)
					})
					.catch(() => {
						this.loginError = true
						this.procesing = false
					})
			}
		},

		loginSuccess(access_token, logged_user) {
			onLogin(this.$apollo.provider.defaultClient, access_token, logged_user).then(() => {
				this.$store.commit("authSuccess", {
					user: logged_user,
					token: access_token
				})
				this.procesing = false

				if (this.redirectTo) {
					this.$router.push(this.redirectTo)
					// window.location.href = this.redirectTo
				} else {
					window.location.href = "/"
				}
			})
		}
	},
	i18n: {
		messages: {
			es: {
				login: "Ingresar",
				loginin: "Ingresando",
				loginSubtitle: "Ingresá a tu cuenta con tu usuario y contraseña",
				email: "Email",
				password: "Contraseña",
				forgetPassword: "¿Olvidó su contraseña?",
				loginFacebook: "Ingresar con Facebook",
				logoutFacebook: "Salir",
				loginGoogle: "Ingresar con Google",
				loginError: "Usuario y/o contraseña incorrectos",
				notRegistered: "¿No tienes cuenta? Regístrate"
			},
			en: {
				login: "Login",
				loginin: "Login in",
				loginSubtitle: "Login to your account with your username and password",
				email: "Email",
				password: "Password",
				forgetPassword: "Forget password?",
				loginFacebook: "Login with Facebook",
				logoutFacebook: "Logout",
				loginGoogle: "Login with Google",
				loginError: "Incorrect username and / or password",
				notRegistered: "Don't have an account yet? Sign up"
			},
			pt: {
				login: "Entrar",
				loginin: "Entrando",
				loginSubtitle: "Faça login em sua conta com seu nome de usuário e senha",
				email: "Email",
				password: "Senha",
				forgetPassword: "¿Esqueceu sua senha?",
				loginFacebook: "Entrar com o Facebook",
				logoutFacebook: "Sair",
				loginGoogle: "Entrar com o  con Google",
				loginError: "Nome de usuário e / ou senha incorretos",
				notRegistered: "Você não tem uma conta? cadastre-se"
			}
		}
	}
}
</script>

<style scoped>
.or {
	width: 100%;
	height: 18px;
	position: relative;
}
.or:after {
	content: "o";
	width: 40px;
	font-size: 0.7rem;
	position: absolute;
	left: calc(50% - 20px);
	top: 0px;
	background-color: #fff;
	text-align: center;
	color: #9c9c9c;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
}
.or:before {
	content: "";
	position: absolute;
	left: 0px;
	top: 8px;
	width: 100%;
	border-bottom: 1px solid #cfcfcf;
}
.terms {
	font-size: 0.8rem;
	line-height: 1rem;
	color: #999;
}
.btn.btn-primary {
	margin-top: 18px;
	width: 100%;
}

.loginBtn--facebook {
	background-color: #4c69ba;
}
.loginBtn--facebook:before {
	background: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_facebook.png") 6px 6px no-repeat;
}
.loginBtn--facebook:hover,
.loginBtn--facebook:focus {
	color: #fff;
	background-color: #5b7bd5;
}

.loginBtn--google {
	background: #dd4b39;
}
.loginBtn--google:before {
	background: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_google.png") 6px 10px no-repeat;
}
.loginBtn--google:hover,
.loginBtn--google:focus {
	color: #fff;
	background: #e74b37;
}
</style>
